import classNames from 'classnames';

import { useTheme } from '../../contexts/ThemeContext';

import styles from '../../../styles/icons/simon-center-button.module.scss';

interface SimonCenterButtonIconProps {
    down?: boolean;
    backgroundColor?: string;
    shadowColor?: string;
    className?: string;
}

const SimonCenterButtonIcon = ({
    down = false,
    backgroundColor = '#E20025',
    shadowColor = '#AA1F2E',
    className = null,
}: SimonCenterButtonIconProps) => {
    const { name: themeName, isVariant } = useTheme();
    let finalBackgroundColor = backgroundColor;
    let finalShadowColor = shadowColor;
    if (themeName === 'iga_noel' && isVariant('bonichoix')) {
        finalBackgroundColor = '#ADDFE8';
        finalShadowColor = '#06172A';
    } else if (themeName === 'iga_noel' && isVariant('tradition')) {
        finalBackgroundColor = '#DE2139';
        finalShadowColor = '#9C0E20';
    }
    return (
        <svg
            x="0"
            y="0"
            viewBox="0 0 136 146"
            xmlSpace="preserve"
            xmlns="http://www.w3.org/2000/svg"
            className={classNames([
                styles.container,
                { [styles.down]: down, [className]: className !== null },
            ])}
        >
            {themeName === 'coorslive' ? (
                <>
                    <rect
                        y="4"
                        width="136"
                        height="136"
                        rx="68"
                        fill={down ? finalBackgroundColor : finalShadowColor}
                    />
                    <rect
                        width="136"
                        height="136"
                        rx="68"
                        fill={down ? finalShadowColor : finalBackgroundColor}
                    />
                </>
            ) : (
                <>
                    <path
                        d="M104.8 6.8H45.5c-5.6 0-10.8 3-13.7 7.9L2.1 66.1C-.7 71-.7 77 2.1 81.9l29.7 51.4c2.8 4.9 8 7.9 13.7 7.9h59.3c5.6 0 10.8-3 13.7-7.9l29.7-51.4c2.8-4.9 2.8-10.9 0-15.8l-29.7-51.4c-2.8-4.9-8-7.9-13.7-7.9z"
                        fill={down ? finalBackgroundColor : finalShadowColor}
                    />
                    <path
                        d="M104.8 0H45.5c-5.6 0-10.8 3-13.7 7.9L2.1 59.3c-2.8 4.9-2.8 10.9 0 15.8l29.7 51.4c2.8 4.9 8 7.9 13.7 7.9h59.3c5.6 0 10.8-3 13.7-7.9l29.7-51.4c2.8-4.9 2.8-10.9 0-15.8L118.5 7.9c-2.8-4.9-8-7.9-13.7-7.9z"
                        fill={down ? finalShadowColor : finalBackgroundColor}
                    />
                </>
            )}
        </svg>
    );
};

export default SimonCenterButtonIcon;
